"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _ImageReplacementAnchorModule = _interopRequireDefault(require("./../../scss/utils/ImageReplacementAnchor.module.scss"));
function ImageReplacementAnchor(_ref) {
  let {
    href = '',
    target = '_self',
    image = {
      url: '',
      width: 1,
      height: 1
    },
    text = '',
    height = 4,
    baselineAdjustment = 0,
    classname = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _helpers.classes)([_ImageReplacementAnchorModule.default['image-replacement-anchor'], 'image-replacement-anchor', classname]),
    href: href,
    target: target,
    rel: target === '_blank' ? 'noreferrer' : null,
    style: {
      '--ira-aspect-ratio': image.width / image.height,
      '--ira-height': "".concat(height, "rem"),
      '--ira-baseline-adjustment': "".concat(baselineAdjustment, "rem")
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image.url,
    className: _ImageReplacementAnchorModule.default['image-replacement-anchor__image'],
    alt: "",
    role: "presentation",
    loading: "lazy"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _ImageReplacementAnchorModule.default['image-replacement-anchor__text']
  }, text));
}
var _default = exports.default = ImageReplacementAnchor;